/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetMiniReference,
    AssetMiniReferenceFromJSON,
    AssetMiniReferenceFromJSONTyped,
    AssetMiniReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetSubtitleLinkUpdate
 */
export interface AssetSubtitleLinkUpdate {
    /**
     * 
     * @type {AssetMiniReference}
     * @memberof AssetSubtitleLinkUpdate
     */
    subtitle: AssetMiniReference;
    /**
     * 
     * @type {string}
     * @memberof AssetSubtitleLinkUpdate
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof AssetSubtitleLinkUpdate
     */
    key: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetSubtitleLinkUpdate
     */
    asset: number;
}

export function AssetSubtitleLinkUpdateFromJSON(json: any): AssetSubtitleLinkUpdate {
    return AssetSubtitleLinkUpdateFromJSONTyped(json, false);
}

export function AssetSubtitleLinkUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetSubtitleLinkUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subtitle': AssetMiniReferenceFromJSON(json['subtitle']),
        'label': json['label'],
        'key': json['key'],
        'asset': json['asset'],
    };
}

export function AssetSubtitleLinkUpdateToJSON(value?: AssetSubtitleLinkUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subtitle': AssetMiniReferenceToJSON(value.subtitle),
        'label': value.label,
        'key': value.key,
        'asset': value.asset,
    };
}


